/**
 * Redirect-URL's voor Supabase Auth-mails (signup-bevestiging, resend).
 * Moeten exact in Dashboard → Authentication → URL Configuration staan (geen wildcard als Site URL).
 */

export function klantSignupEmailRedirectUrl (): string | undefined {
  return typeof window !== 'undefined' ? `${window.location.origin}/klant/login` : undefined
}

export function zakelijkSignupEmailRedirectUrl (): string | undefined {
  return typeof window !== 'undefined' ? `${window.location.origin}/login` : undefined
}
